import React from "react";
import Sidebar from "../components/Sidebar.jsx";
import { Outlet } from "react-router-dom";
import { SidebarProvider, useSidebar } from "./SidebarContext.jsx";
import "../styles/app.css";

const AppShell = () => {
  const { isSidebarOpen, closeSidebar } = useSidebar();

  return (
    <div className={`app-container ${isSidebarOpen ? "sidebar-open" : ""}`}>
      <Sidebar />

      {isSidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar} />}

      <div className="main-container">
        <Outlet />
      </div>
    </div>
  );
};

const App = () => {
  return (
    <SidebarProvider>
      <AppShell />
    </SidebarProvider>
  );
};

export default App;